<template>
    <div class="vh-dropdown">
        <a
            class="vh-dropdown-select" 
            :class="{ 'vh-dropdown-select-clicked': isDropdownOpen }"
            @click="toggleDropdown">
                <span class="vh-dropdown-selected">{{ selectedOption }}</span>
                <i class="bx bx-chevron-down"></i>
        </a>
        <ul 
            class="vh-dropdown-menu vh-box-shadow-small" 
            :class="{ 'vh-dropdown-menu-open': isDropdownOpen }">
            <li 
                v-for="option in options" 
                :key="option" 
                :class="{ 'active': option === selectedOption }"
                @click="selectOption(option)">
                {{ option }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props:
    {
        options:
        {
            type: Array,
            required: true
        },
        defaultOption:
        {
            type: String,
            default: ''
        }
    },
    data()
    {
        return{
            selectedOption: this.defaultOption,
            isDropdownOpen: false
        };
    },
    mounted()
    {
        window.addEventListener('click', this.clickOutside);
    },
    methods:
    {
        toggleDropdown()
        {
            this.isDropdownOpen = !this.isDropdownOpen;
        },
        selectOption(option)
        {
            this.selectedOption = option;
            this.isDropdownOpen = false;
        },
        clickOutside(event)
        {
            if (!this.$el.contains(event.target))
            {
                this.isDropdownOpen = false;
            }
        },
    },
}
</script>
